<template>
  <div class="home">
    <headline />
    <div class="wheel-planting">
      
      <Carousel v-model="imgName" arrow="never" loop autoplay :autoplay-speed="5000">
        <CarouselItem>
          <div class="carousel-one">
            <img class="demo-carousel" src="./img/u11.jpg" />
            <div class="content">
              <p>面向未来的智能学校体育管理平台</p>
              <section class="second_content">
                <p>
                  排课、选课、考勤、锻炼、考试、场馆、体测、
                  器材等一站式服务，去繁就简，专注提升工作效率
                </p>
                <p class="apply_button" @click="$router.push('trial')">申请试用</p>
              </section>
            </div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="carousel-tow">
            <img class="demo-carousel" src="./img/u2.jpg" />
            <div class="content">
              <p>在线留作业 随时随地课堂互动</p>
              <section class="second_content">
                <p>
                  指尖轻触，即可给全班同学，在线布置作业，重点、难点动作回放，
                  互联网+体育授课模式妙不可言。
                </p>
                <p class="apply_button" @click="$router.push('introductionProduct')">了解详情</p>
              </section>
            </div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="carousel-three">
            <img class="demo-carousel" src="./img/u3.jpg" />
            <div class="content">
              <p>丰富的优质体育课教学视频资源</p>
              <section class="second_content">
                <p>
                  海量体育课教案，体育专业院校教授团队编写
                  配套动作视频，教学素材，丰富教学组织形式
                </p>
                <p class="apply_button" @click="$router.push('introductionProduct')">立即体验</p>
              </section>
            </div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="carousel-four">
            <img class="demo-carousel" src="./img/u4.jpg" />
            <div class="content">
              <p>一站式管理平台，数据可视化服务</p>
              <section class="second_content">
                <p>构建业务标准规范，让流程融于工作中的每个环节</p>
                <p class="apply_button" @click="$router.push('introductionProduct')">了解详情</p>
              </section>
            </div>
          </div>
        </CarouselItem>
      </Carousel>
      <div class="download">
        <Button type="default" ghost class="download-button">
          <a @click="top">IOS下载</a>
        </Button>
        <Button type="default" ghost class="download-button">
          <a @click="top">Android下载</a>
        </Button>
      </div>
    </div>
    <div class="business">
      <h1 class="home-title">我们的业务</h1>
      <p class="home-introduce">从PC端到移动互联网，打造全方位的互联网综合体系</p>
      <div class="business-content">
        <div class="business-content-cell">
          <div>
            <img src="./img/teaching.png" alt />
            <p>体育教学</p>
          </div>
          <div>
            <img src="./img/physical-exercise.png" alt />
            <p>课外锻炼</p>
          </div>
          <div>
            <img src="./img/test.png" alt />
            <p>体质测试</p>
          </div>
          <div>
            <img src="./img/venue.png" alt />
            <p>场馆管理</p>
          </div>
          <div>
            <img src="./img/competition.png" alt />
            <p>竞赛管理</p>
          </div>
        </div>
        <div class="business-content-cell">
          <div>
            <img src="./img/approval.png" alt />
            <p>审批管理</p>
          </div>
          <div>
            <img src="./img/data-analysis.png" alt />
            <p>数据分析</p>
          </div>
          <div>
            <img src="./img/department.png" alt />
            <p>部门管理</p>
          </div>
          <div>
            <img src="./img/notice.png" alt />
            <p>通知</p>
          </div>
          <div>
            <img src="./img/scientific-research.png" alt />
            <p>科研管理</p>
          </div>
        </div>
      </div>
    </div>
    <div class="service">
      <h1 class="home-title">支持服务</h1>
      <h2 class="home-introduce">从PC到移动互联网，打造全方位的互联网综合体系</h2>
      <div class="service-content">
        <div>
          <div>
            <img src="./img/customize.png" alt />
          </div>
          <p>个性化订制服务</p>
        </div>
        <div>
          <div>
            <img src="./img/data.png" alt />
          </div>
          <p>数据服务</p>
        </div>
        <div>
          <div>
            <img src="./img/education.png" alt />
          </div>
          <p>教学资源制作</p>
        </div>
        <div>
          <div>
            <img src="./img/review.png" alt />
          </div>
          <p>在线评审平台</p>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import headline from "@/components/headline/headline";
import foot from "@/components/foot/foot";

export default {
  name: "Home",
  data() {
    return {
      imgName: 0
    };
  },
  methods: {
    top() {
      document.querySelector("#BottomDownload").scrollIntoView(true);
    }
  },
  components: {
    headline,
    foot
  }
};
</script>

<style lang="less" scoped>
@import "../../common/font/font.css";
.home {
  /deep/ .ivu-carousel-dots li.ivu-carousel-active > button {
    background: #fff;
  }
  .wheel-planting {
    position: relative;
    background: #eff2f7;
    /deep/.ivu-carousel-item {
      max-height: 9rem !important;
    }
    .ivu-carousel {
      /deep/.ivu-carousel-dots {
        margin-bottom: 20px;
        li {
          margin: 0 5px;
          button {
            width: 44px;
          }
        }
      }
    }
    .demo-carousel {
      width: 100%;
      display: block;
      max-height: 84vh;
      // min-width: 1200px;
      object-fit: cover;
    }
    .download {
      position: absolute;
      bottom: 0.4rem;
      right: 1rem;
      .download-button {
        border-radius: 0.23rem;
        margin-left: 0.1rem;
        width: 1.2rem;
        height: 0.46rem;
        font-size: 0.16rem;
        a {
          color: white;
        }
      }
      .download-button:hover {
        a {
          color: #57a3f3;
        }
      }
    }
  }
  .business {
    width: 100%;
    // height: 6.75rem;
    background: rgba(239, 242, 247, 1);
    .business-content {
      text-align: center;
      margin-top: 0.6rem;
      .business-content-cell {
        display: flex;
        justify-content: center;
        margin-top: 0.45rem;
        & > div {
          width: 1.7rem;
          height: 1.7rem;
          margin: 0.2rem 0.3rem;
          p {
            font-size: 0.18rem;
            font-weight: 500;
            color: rgba(34, 34, 34, 1);
            margin-top: 0.2rem;
          }
        }
      }
    }
  }
  .service {
    width: 100%;
    height: 5.4rem;
    background: rgba(239, 242, 247, 1);
    .service-content {
      display: flex;
      justify-content: center;
      margin-top: 0.6rem;
      & > div {
        text-align: center;
        width: 2.65rem;
        height: 2.25rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.04rem;
        margin: 0 0.1rem;
        & > div {
          width: 1.2rem;
          height: 1.2rem;
          margin: 0.3rem auto 0;
        }
        p {
          font-size: 0.18rem;
          font-weight: 500;
          color: rgba(34, 34, 34, 1);
          margin-top: 0.2rem;
        }
      }
    }
  }
  .home-title {
    text-align: center;
    padding-top: 0.4rem;
    font-size: 0.36rem;
    font-weight: 600;
    color: rgba(34, 34, 34, 1);
  }
  .home-introduce {
    text-align: center;
    margin-top: 0.2rem;
    font-size: 0.28rem;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
}
.carousel-one {
  position: relative;
}

.content {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 1.5rem;
  > p:first-of-type {
    font-size: 0.5rem;
    color: #fff;
    font-weight: bold;
    letter-spacing: 2px;
    font-family: Source Han Sans CN;
  }
  > .second_content {
    width: 6.2rem;
    margin: 0.4rem 0 0;
    line-height: 0.44rem;
    color: #fff;
    > p:first-of-type {
      font-size: 0.28rem;
    }
    > .apply_button {
      cursor: pointer;
      width: 1.8rem;
      height: 0.4rem;
      margin: 0.4rem auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.2rem;
      padding-bottom: 0.04rem;
      color: #fff;
      background: #ff9f38;
      box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.34);
      border-radius: 0.08rem;
    }
  }
}
.carousel-tow {
  position: relative;
  .second_content {
    width: 8.5rem;
    .apply_button {
      margin-left: 3.1rem;
      transform: translateX(-50%);
    }
  }
}
.carousel-three {
  position: relative;
}
.carousel-four {
  position: relative;
  .second_content {
    width:7.8rem;
    text-align: center;
  }
}
.carousel-one,
.carousel-tow,
.carousel-three,
.carousel-four {
  // font-family:"微软雅黑"
  font-family: "MicrosoftYaHei";
}

@media screen and (max-width: 1440px) {
}
@media screen and (max-width: 900px) {
  .carousel-one {
    & > div div {
      line-height: 0.4rem;
    }
  }
  .download-button {
    width: 2.2rem !important;
    height: 0.52rem !important;
  }
  .business-content-cell {
    & > div img {
      width: 1rem;
    }
  }
  .service-content {
    & > div {
      & > div img {
        width: 0.7rem;
      }
    }
  }
}
</style>
